import { render } from "./ConfigPage.vue?vue&type=template&id=2994c90f&ts=true"
import script from "./ConfigPage.vue?vue&type=script&lang=ts"
export * from "./ConfigPage.vue?vue&type=script&lang=ts"

import "./ConfigPage.vue?vue&type=style&index=0&id=2994c90f&lang=scss"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/DangKyKB_HV/DKKB_new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__